import PropTypes from 'prop-types';
import React from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import ReactModal from 'react-modal';
import VM from 'scratch-vm';
import { defineMessages, injectIntl, intlShape } from 'react-intl';

import ErrorBoundaryHOC from '../lib/error-boundary-hoc.jsx';
import {
    getIsError,
    getIsShowingProject,
    requestNewProject
} from '../reducers/project-state';
import {
    activateTab,
    BLOCKS_TAB_INDEX,
    COSTUMES_TAB_INDEX,
    SOUNDS_TAB_INDEX
} from '../reducers/editor-tab';

import {
    closeCostumeLibrary,
    closeBackdropLibrary,
    closeTelemetryModal,
    openExtensionLibrary
} from '../reducers/modals';

import FontLoaderHOC from '../lib/font-loader-hoc.jsx';
import LocalizationHOC from '../lib/localization-hoc.jsx';
import ProjectFetcherHOC from '../lib/project-fetcher-hoc.jsx';
import TitledHOC from '../lib/titled-hoc.jsx';
import ProjectSaverHOC from '../lib/project-saver-hoc.jsx';
import QueryParserHOC from '../lib/query-parser-hoc.jsx';
import storage from '../lib/storage';
import vmListenerHOC from '../lib/vm-listener-hoc.jsx';
import vmManagerHOC from '../lib/vm-manager-hoc.jsx';
import cloudManagerHOC from '../lib/cloud-manager-hoc.jsx';

import GUIComponent from '../components/gui/gui.jsx';
import { setIsScratchDesktop } from '../lib/isScratchDesktop.js';
import log from '../lib/log';

import {
    closeFileMenu
} from '../reducers/menus';
import {
    LoadingStates,
    onLoadedProject
} from '../reducers/project-state';
import {
    closeLoadingProject
} from '../reducers/modals';
import {
    lmsDataService
} from '../reducers/99lmsdatashare';

class GUI extends React.Component {
    componentDidMount() {

        try {   

            localStorage.removeItem('vc2Obj');

            var mql = window.matchMedia("(orientation: portrait)");

            // If there are matches, we're in portrait
            if(mql.matches) {  
                // Portrait orientation
                alert("For best experience switch to landscape mode and refresh")
            } else {
                // Landscape orientation
            }

            // if (screen.orientation.type == 'portrait-primary') {
            //     alert("For best experience switch to landscape mode and refresh")
            // }
        } catch (e) {}

        setIsScratchDesktop(this.props.isScratchDesktop);
        this.props.onStorageInit(storage);
        this.props.onVmInit(this.props.vm);

        if (window.parent) {
            window.parent.postMessage({ status: 'vc2-ready' }, '*');
        }

        if (window.opener) {
            window.opener.postMessage({ status: 'vc2-ready' }, '*');
        }

        window.addEventListener('message', event => {
            var data = event.data;
            if(data['newProject']){
                this.updateContentInS3();
            }
            
            if (data['status'] == 'loadFile') {
                this.setDataProps(data)
                if (data['viewOnly']) {
                    lmsDataService.setData({ viewOnly: true }, 'viewMode');
                } else {
                    lmsDataService.clearData('viewMode');
                }
                const s3File = data['value'].replace('files', lmsDataService.getData('S3_BASE_URL'));
                var request = new XMLHttpRequest();
                request.open('GET', s3File, true);
                request.responseType = 'blob';
                request.onload = () => {
                    new Response(request.response).arrayBuffer().then((bufferData) => {
                        this.loadProjectFromArrayBuffer(bufferData, 'test.sb3');
                        if (data['editTeacherSharedFile']) {
                            lmsDataService.setData({ mode: 'editTeacherSharedFile', filePath: s3File }, 'editMode');
                        } else {
                            lmsDataService.setData({ mode: 'edit', filePath: s3File }, 'editMode');
                        }
                    });
                };
                request.send();
            } else if (data['status'] == 'newFile') {
                this.setDataProps(data)
                lmsDataService.setData({ mode: 'newFile' }, 'editMode');
            } else if (data['status'] == 'fromIde') {
                this.setDataProps(data);
                lmsDataService.setData({ mode: 'newFile' }, 'editMode');
            } else if (data['status'] == 'closeProject') {
                this.setDataProps(data);;
                lmsDataService.setData({ mode: 'newFile' }, 'editMode');
                this.createNewFile(data['needPrompt']);
            }
            
        });

    }

    setDataProps(data){
        lmsDataService.clearData('pathToSave');
        lmsDataService.clearData('independentProject');
        lmsDataService.clearData('fileName');
        if (data['pathToSave']) {
            lmsDataService.setData(data['pathToSave'], 'pathToSave');
        }
        if (data['independentProject']) {
            lmsDataService.setData(true, 'independentProject');
        }
        if (data['fileName']) {
            lmsDataService.setData(data['fileName'], 'fileName');
        }
        if(data['status']? data['status'] == 'loadFile' || data['status'] == 'newFile': ''){
            lmsDataService.setData(true, 'showSave');
        } else{
            lmsDataService.setData(false, 'showSave');
        }
    }

    fnConvertBlobToFile(content, fileName) {
        const myPromise = new Promise((resolve, reject) => {
            resolve(new File([content], fileName), { type: 'application/x.scratch.sb3' });
        });
        return myPromise;
    }



    createNewFile(needPrompt) {

        if(needPrompt){
            if(confirm('Close current project and replace its contents?')){
                this.props.onClickNew(this.props.canSave && this.props.canCreateNew);
            }
        }
        else {
            this.props.onClickNew(this.props.canSave && this.props.canCreateNew); 
        }

        // this.props.onRequestCloseFile();
        // if (readyToReplaceProject) {
        // }
        // this.props.onRequestCloseFile();
    }

    updateContentInS3(){
       

        this.props.saveProjectSb3().then(content => {

           

            if (this.props.onSaveFinished) {
                this.props.onSaveFinished();
            }

            const editMode = lmsDataService.getData('editMode');
            let pathToSave = lmsDataService.getData('pathToSave');
            if(pathToSave){
                pathToSave = pathToSave.replace("files/", '');
            }
            const fileName = pathToSave.split('/')[pathToSave.split('/').length - 1];
            pathToSave = pathToSave.replace("/" + fileName, '')

            setTimeout(() => {
                
                this.fnConvertBlobToFile(content,fileName).then(function (file) {
                    var xhr = new XMLHttpRequest();
                    xhr.open("POST", lmsDataService.getData('API_URL'), true);

                    var formdata = new FormData();
                    formdata.append("file", file);

                    formdata.append("pathToBeSave", (pathToSave?pathToSave:'scratchQuestionScratchFiles'));
                    formdata.append("fileName", fileName);
                    formdata.append("overwrite", true);
                    
                    xhr.send(formdata);
                    xhr.onreadystatechange = function () {
                        if (xhr.readyState == 4 && xhr.status == 200) {

                            lmsDataService.setData(true, 'fileSaved');
                            if(pathToSave){
                                pathToSave = pathToSave + '/'+ fileName
                            }
                            const message = {
                                status: 'fileSaved',
                                value: (pathToSave?pathToSave:'files/' + 'scratchQuestionScratchFiles/' + xhr.response.replace('"', '').replace('"', ''))
                            };

                            if (window.parent) {
                                window.parent.postMessage(message, '*');
                            }
                    
                            if (window.opener) {
                                window.opener.postMessage(message, '*');
                            }
                            
                        }
                    };

                })
            }, 300);
        });

    }


    componentDidUpdate(prevProps) {
        if (this.props.projectId !== prevProps.projectId && this.props.projectId !== null) {
            this.props.onUpdateProjectId(this.props.projectId);
        }
        if (this.props.isShowingProject && !prevProps.isShowingProject) {
            // this only notifies container when a project changes from not yet loaded to loaded
            // At this time the project view in www doesn't need to know when a project is unloaded
            this.props.onProjectLoaded();
        }
    }

    loadProjectFromArrayBuffer(data, filename) {
        this.props.vm.loadProject(data)
            .then(() => {
                this.props.onLoadingFinished(this.props.loadingState, true);
                // Reset the file input after project is loaded
                // This is necessary in case the user wants to reload a project
                if (filename) {
                    const uploadedProjectTitle = this.getProjectTitleFromFilename(filename);
                    this.props.onReceivedProjectTitle(uploadedProjectTitle);
                }
            });
    }

    render() {
        if (this.props.isError) {
            throw new Error(
                `Error in Scratch GUI [location=${window.location}]: ${this.props.error}`);
        }
        const {
            /* eslint-disable no-unused-vars */
            assetHost,
            cloudHost,
            error,
            isError,
            isScratchDesktop,
            isShowingProject,
            onProjectLoaded,
            onStorageInit,
            onUpdateProjectId,
            onVmInit,
            projectHost,
            projectId,
            /* eslint-enable no-unused-vars */
            children,
            fetchingProject,
            isLoading,
            loadingStateVisible,
            ...componentProps
        } = this.props;
        return (
            <GUIComponent
                loading={fetchingProject || isLoading || loadingStateVisible}
                {...componentProps}
            >
                {children}
            </GUIComponent>
        );
    }
}

GUI.propTypes = {
    assetHost: PropTypes.string,
    children: PropTypes.node,
    cloudHost: PropTypes.string,
    error: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
    fetchingProject: PropTypes.bool,
    intl: intlShape,
    isError: PropTypes.bool,
    isLoading: PropTypes.bool,
    isScratchDesktop: PropTypes.bool,
    isShowingProject: PropTypes.bool,
    loadingStateVisible: PropTypes.bool,
    onProjectLoaded: PropTypes.func,
    onSeeCommunity: PropTypes.func,
    onStorageInit: PropTypes.func,
    onUpdateProjectId: PropTypes.func,
    onVmInit: PropTypes.func,
    projectHost: PropTypes.string,
    projectId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    telemetryModalVisible: PropTypes.bool,
    vm: PropTypes.instanceOf(VM).isRequired,
    onLoadingFinished: PropTypes.func,
    loadingState: PropTypes.oneOf(LoadingStates),
    saveProjectSb3: PropTypes.func,
    onClickNew : PropTypes.func,
    canSave: PropTypes.bool,
    canCreateNew: PropTypes.bool
};

GUI.defaultProps = {
    isScratchDesktop: false,
    onStorageInit: storageInstance => storageInstance.addOfficialScratchWebStores(),
    onProjectLoaded: () => { },
    onUpdateProjectId: () => { },
    onVmInit: (/* vm */) => { }
};

const messages = defineMessages({
    loadError: {
        id: 'gui.projectLoader.loadError',
        defaultMessage: 'The project file that was selected failed to load.',
        description: 'An error that displays when a local project file fails to load.'
    }
});

const mapStateToProps = state => {
    const loadingState = state.scratchGui.projectState.loadingState;
    return {
        activeTabIndex: state.scratchGui.editorTab.activeTabIndex,
        alertsVisible: state.scratchGui.alerts.visible,
        backdropLibraryVisible: state.scratchGui.modals.backdropLibrary,
        blocksTabVisible: state.scratchGui.editorTab.activeTabIndex === BLOCKS_TAB_INDEX,
        cardsVisible: state.scratchGui.cards.visible,
        connectionModalVisible: state.scratchGui.modals.connectionModal,
        costumeLibraryVisible: state.scratchGui.modals.costumeLibrary,
        costumesTabVisible: state.scratchGui.editorTab.activeTabIndex === COSTUMES_TAB_INDEX,
        error: state.scratchGui.projectState.error,
        isError: getIsError(loadingState),
        isFullScreen: state.scratchGui.mode.isFullScreen,
        isPlayerOnly: state.scratchGui.mode.isPlayerOnly,
        isRtl: state.locales.isRtl,
        isShowingProject: getIsShowingProject(loadingState),
        loadingStateVisible: state.scratchGui.modals.loadingProject,
        projectId: state.scratchGui.projectState.projectId,
        soundsTabVisible: state.scratchGui.editorTab.activeTabIndex === SOUNDS_TAB_INDEX,
        targetIsStage: (
            state.scratchGui.targets.stage &&
            state.scratchGui.targets.stage.id === state.scratchGui.targets.editingTarget
        ),
        telemetryModalVisible: state.scratchGui.modals.telemetryModal,
        tipsLibraryVisible: state.scratchGui.modals.tipsLibrary,
        vm: state.scratchGui.vm,
        saveProjectSb3: state.scratchGui.vm.saveProjectSb3.bind(state.scratchGui.vm)
    };
};

const mapDispatchToProps = (dispatch, ownProps) => ({
    onExtensionButtonClick: () => dispatch(openExtensionLibrary()),
    onActivateTab: tab => dispatch(activateTab(tab)),
    onActivateCostumesTab: () => dispatch(activateTab(COSTUMES_TAB_INDEX)),
    onActivateSoundsTab: () => dispatch(activateTab(SOUNDS_TAB_INDEX)),
    onRequestCloseBackdropLibrary: () => dispatch(closeBackdropLibrary()),
    onRequestCloseCostumeLibrary: () => dispatch(closeCostumeLibrary()),
    onRequestCloseTelemetryModal: () => dispatch(closeTelemetryModal()),
    onLoadingFinished: (loadingState, success) => {
        dispatch(onLoadedProject(loadingState, ownProps.canSave, success));
        dispatch(closeLoadingProject());
        dispatch(closeFileMenu());
    },
    onClickNew: needSave => dispatch(requestNewProject(needSave)),
});

const ConnectedGUI = injectIntl(connect(
    mapStateToProps,
    mapDispatchToProps,
)(GUI));

// note that redux's 'compose' function is just being used as a general utility to make
// the hierarchy of HOC constructor calls clearer here; it has nothing to do with redux's
// ability to compose reducers.
const WrappedGui = compose(
    LocalizationHOC,
    ErrorBoundaryHOC('Top Level App'),
    FontLoaderHOC,
    QueryParserHOC,
    ProjectFetcherHOC,
    TitledHOC,
    ProjectSaverHOC,
    vmListenerHOC,
    vmManagerHOC,
    cloudManagerHOC
)(ConnectedGUI);

WrappedGui.setAppElement = ReactModal.setAppElement;
export default WrappedGui;
